import { getPremiumDepositStatus } from '../../cred';

export const initialSelectStatus = {
	selectUser: 'NA',
};

const getSelectStatus = async () => {
	const { status, msg } = await getPremiumDepositStatus();

	if (status === 1) {
		return {
			selectUser: msg,
		};
	}

	return {};
};

// ------------------------------------------------------------

export const selectStatusActions = {
	__getSelectStatus: getSelectStatus,
};
